import React from 'react';
import { Note, NoteTextContainer, NoteSpan, NoteText, NoteTitle, NotesContainer } from './Notes.styled';
import { connect } from 'react-redux';

interface ITemplateNotes {
   source: string;
   publicationDate: string;
   lastModifiedTimestamp: string;
   note: string;
   additionalNote: string;
   methodology: string;
}

function mapStateToProps(state) {
   return {
      source: state.template.source,
      publicationDate: state.template.publicationDate,
      lastModifiedTimestamp: state.template.lastModifiedTimestamp,
      note: state.template.note,
      additionalNote: state.template.additionalNote,
      methodology: state.template.methodology
   };
}

export class Notes extends React.Component<ITemplateNotes, {}> {
   public render() {
      const { source, publicationDate, lastModifiedTimestamp, note, additionalNote, methodology } = this.props;

      return (
         <NotesContainer justifyContent='start' alignItems='start' spaceBetween={36}>
            {source ? (
               <Note>
                  <NoteTextContainer>
                     <NoteTitle>Source:&nbsp;</NoteTitle>
                     <NoteText itemProp='sourceOrganization'>{source}</NoteText>
                     {publicationDate && publicationDate !== '' ? (
                        <NoteSpan itemProp='datePublished'>
                           ,&nbsp;{global.Intl.DateTimeFormat('en-us', { timeZone: 'UTC', year: 'numeric', month: 'long' }).format(new Date(publicationDate))}
                           &nbsp;
                        </NoteSpan>
                     ) : (
                        <span />
                     )}
                     {lastModifiedTimestamp && lastModifiedTimestamp !== '' ? (
                        <NoteSpan itemProp='lastModifiedTimestamp'>
                           -&nbsp;
                           {global.Intl.DateTimeFormat('en-us', { timeZone: 'UTC', year: 'numeric', month: 'long' }).format(new Date(lastModifiedTimestamp))}
                           &nbsp;
                        </NoteSpan>
                     ) : (
                        <span />
                     )}
                  </NoteTextContainer>
               </Note>
            ) : null}
            {note ? (
               <Note>
                  <NoteTextContainer>
                     <NoteTitle>Note:&nbsp;</NoteTitle>
                     <NoteText dangerouslySetInnerHTML={{ __html: note }} itemProp='sourceOrganization' />
                  </NoteTextContainer>
               </Note>
            ) : null}
            {additionalNote ? (
               <Note>
                  <NoteTextContainer>
                     <NoteTitle>Additional Note:&nbsp;</NoteTitle>
                     <NoteText dangerouslySetInnerHTML={{ __html: additionalNote }} itemProp='sourceOrganization' />
                  </NoteTextContainer>
               </Note>
            ) : null}
            {methodology ? (
               <Note>
                  <NoteTextContainer>
                     <NoteTitle>Methodology:&nbsp;</NoteTitle>
                     <NoteText dangerouslySetInnerHTML={{ __html: methodology }} itemProp='sourceOrganization' />
                  </NoteTextContainer>
               </Note>
            ) : null}
         </NotesContainer>
      );
   }
}

export default connect(mapStateToProps, null)(Notes);
